import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/view/Home.vue';
import store from '@/store';
/*hold*/
import HoldTicketTable from "@/view/hold/pages/HoldTicketTable.vue";
import EditHoldTicketPage from "@/view/hold/pages/EditHoldTicketPage.vue";
import AddHoldTicketPage from "@/view/hold/pages/AddHoldTicketPage.vue";
import SearchHoldTicketPage from "@/view/hold/pages/SearchHoldTicketPage.vue";
import HoldSearchResultsPage from "@/view/hold/pages/HoldSearchResultsPage.vue";
import ViewHoldTicketPage from "@/view/hold/pages/ViewHoldTicketPage.vue";
import PrintHoldTicketTable from "@/view/hold/pages/PrintHoldTicketTable.vue";
/*wip*/
import WipTicketTable from '@/view/wip/pages/WipTicketTable.vue';
import EditWipTicketPage from "@/view/wip/pages/EditWipTicketPage.vue";
import AddWipTicketPage from "@/view/wip/pages/AddWipTicketPage.vue";
import ViewWipTicketPage from "@/view/wip/pages/ViewWipTicketPage.vue";
import PrintWipTicketTable from "@/view/wip/pages/PrintWipTicketTable.vue";
import SearchWipTicketPage from "@/view/wip/pages/SearchWipTicketPage.vue";
import WipSearchResultsPage from "@/view/wip/pages/WipSearchResultsPage.vue";
/*admin*/
import ManageEmailPage from '@/view/admin/pages/ManageEmailPage.vue';
/*auth/profile*/
import Login from '@/view/auth/Login.vue';
import Profile from "@/view/profile/Profile.vue";
import SubscriptionPage from "@/view/profile/pages/SubscriptionPage.vue";

// https://router.vuejs.org/guide/advanced/navigation-guards.html#per-route-guard
// probably need to change beforeEnter to something else, as you can refresh the page and not have the guard trigger

Vue.use(Router);

function ifAuthenticated(to, from, next){
  if (store.getters.isAuthenticated){
    next();
    return;
  }
  next('/login');
}

function ifAdmin(to, from, next){
  if (store.getters.getGroups.includes('admin')){
    next();
    return;
  }
  next('/')
}


function ifNotAuthenticated(to, from, next){
  if (!store.getters.isAuthenticated){
    next();
    return;
  }
  next('/');
}

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/add-hold-ticket',
      name: 'add-hold-ticket',
      component: AddHoldTicketPage,
      props:true,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/hold-tickets',
      name: 'hold-tickets',
      component: HoldTicketTable,
      props: true,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/print-hold-ticket-table',
      name: 'print-hold-ticket-table',
      component: PrintHoldTicketTable,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/edit-hold-ticket/:holdTicketId',
      name: 'edit-hold-ticket',
      props: true,
      component:  EditHoldTicketPage,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/view-hold-ticket/:holdTicketId',
      name: 'view-hold-ticket',
      props: true,
      component: ViewHoldTicketPage,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/search-hold-ticket',
      name: 'search-hold-ticket',
      props: true,
      component: SearchHoldTicketPage,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/hold-search-results',
      name: 'hold-search-results',
      props: true,
      component: HoldSearchResultsPage,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/wip-tickets',
      name: 'wip-tickets',
      component: WipTicketTable,
      props: true,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/edit-wip-ticket/:wipTicketId',
      name: 'edit-wip-ticket',
      props: true,
      component:  EditWipTicketPage,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/add-wip-ticket',
      name: 'add-wip-ticket',
      props: true,
      component: AddWipTicketPage,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/view-wip-ticket/:wipTicketId',
      name: 'view-wip-ticket',
      props: true,
      component: ViewWipTicketPage,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/print-wip-ticket-table',
      name: 'print-wip-ticket-table',
      component: PrintWipTicketTable,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/search-wip-ticket',
      name: 'search-wip-ticket',
      props: true,
      component: SearchWipTicketPage,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/wip-search-results',
      name: 'wip-search-results',
      props: true,
      component: WipSearchResultsPage,
      beforeEnter: ifAuthenticated
    },
    {
      path:'/admin/emails',
      name: 'manage-emails',
      props: true,
      component: ManageEmailPage,
      beforeEnter: ifAuthenticated && ifAdmin
    },
    {
      path:'/profile',
      name: 'profile',
      props: true,
      component: Profile,
      beforeEnter: ifAuthenticated,
      children: [
        {
          path: 'subscriptions',
          name: 'manage-subscriptions',
          component: SubscriptionPage,
        }
      ]
    },
  ],
});
